import getAppCustomEnv from "@/utilities/get-app-custom-env";
import get from "lodash/get";

class GA4 {
  _GA_MEASUREMENT_ID = null;
  async init(user) {
    const appCustomEnv = await getAppCustomEnv();
    if ("gtag" in window && appCustomEnv.VUE_APP_GA4_KEY) {
      this._GA_MEASUREMENT_ID = appCustomEnv.VUE_APP_GA4_KEY;
      window.gtag("config", this._GA_MEASUREMENT_ID, {
        userId: get(user, "_id", null),
      });
    }
  }

  setUserID(userId) {
    if ("gtag" in window && this._GA_MEASUREMENT_ID) {
      window.gtag("config", this._GA_MEASUREMENT_ID, {
        userId,
      });
    }
  }
}

export default new GA4();
